import { Injectable } from '@angular/core';
import { TokenPropertyService } from './token-property.service';

@Injectable({
  providedIn: 'root'
})
export class AuthContextService {
  private _hasInternalAccess = false;

  constructor(private tokenPropertyService: TokenPropertyService) {
    this.tokenPropertyService.hasInternalAccess().subscribe((hasAccess) => {
      this._hasInternalAccess = hasAccess;
    });
  }

  get hasInternalAccess(): boolean {
    return this._hasInternalAccess;
  }
}